/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

function SEO({ description, lang, meta, title = 'Support Center', keywords, url } = {}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            keywords
          }
        }
      }
    `
  );

  const metaTitleTag = title || site?.metaDescription?.title;
  const metaDescription = description || site.siteMetadata.description;
  const metaKeywords = keywords || site.siteMetadata.keywords;
  const metaUrl = [process.env.GATSBY_SITE_URL, 'help', url]
    .filter(Boolean)
    .join('/')
    .replace(/\/?$/, '/');
  const formattedTitle = `${metaTitleTag} | Carvana`;
  const formattedDescription = `${metaDescription} & The Online Shopping Experience @Carvana | Skip The Dealership & Buy Online @ Carvana.com`;

  return (
    <Helmet
      htmlAttributes={{
        lang
      }}
      title={formattedTitle}
      meta={[
        {
          name: 'description',
          content: formattedDescription
        },
        {
          name: 'keywords',
          content: metaKeywords
        },
        {
          property: 'og:title',
          content: formattedTitle
        },
        {
          property: 'og:description',
          content: formattedDescription
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:url',
          content: metaUrl
        },
        {
          property: 'og:image',
          content:
            'https://carvanablobprod.blob.core.windows.net/vending-machine-landing-page-assets/open-graph.jpg?v=20170412'
        },
        {
          name: 'twitter:card',
          content: 'summary'
        },
        {
          name: 'twitter:title',
          content: formattedTitle
        },
        {
          name: 'twitter:description',
          content: formattedDescription
        },

        // Non-Essential, But Recommended
        {
          property: 'og:site_name',
          content: 'Carvana.com'
        }
      ].concat(meta)}
    />
  );
}

SEO.defaultProps = {
  lang: 'en',
  meta: [],
  description: ''
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired
};

export default SEO;
